// @flow

import React from "react";
import SvgIcon from "material-ui/SvgIcon";

const Unchecked = props => (
  <SvgIcon {...props}>
    <g
      id="ICRA-Assessment"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Contributing-Factors-1-Checked"
        transform="translate(-367.000000, -398.000000)"
        stroke="#012345"
      >
        <g id="Circles" transform="translate(368.000000, 308.500000)">
          <circle id="Oval-Copy-13" cx="8.5" cy="98.5" r="8.5" />
        </g>
      </g>
    </g>
  </SvgIcon>
);

const Checked = props => (
  <SvgIcon {...props}>
    <g
      id="ICRA-Assessment"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Contributing-Factors-2-Checked"
        transform="translate(-367.000000, -465.000000)"
      >
        <g id="Assessment-Content" transform="translate(341.000000, 81.000000)">
          <g id="Body" transform="translate(0.000000, 54.000000)">
            <g
              id="Circles-checked"
              transform="translate(27.000000, 157.000000)"
            >
              <g
                id="Circles-checked-Copy-5"
                transform="translate(0.000000, 173.500000)"
              >
                <g
                  id="Status---Completed"
                  transform="translate(0.000000, 0.500000)"
                >
                  <circle
                    id="Oval-2-Copy"
                    stroke="#00857A"
                    strokeWidth="1.5"
                    fill="#FFFFFF"
                    cx="8.5"
                    cy="8.5"
                    r="8.5"
                  />
                  <path
                    d="M12.1700083,5.96983479 C11.7744638,5.56561062 11.1334089,5.56561062 10.7378644,5.96983479 L7.15713259,9.62025185 L6.26213563,8.70764758 C5.86659112,8.30590332 5.22528824,8.30590332 4.82999172,8.70764758 C4.43444721,9.11187175 4.43444721,9.76656612 4.82999172,10.1683104 L6.44118462,11.812486 C6.83672913,12.2167102 7.47778403,12.2167102 7.87332854,11.812486 L12.1700083,7.4304976 C12.5655528,7.02627342 12.5655528,6.37157906 12.1700083,5.96983479 L12.1700083,5.96983479 Z"
                    id="Fill-34-Copy-2"
                    fill="#00857A"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

const Add = props => (
  <SvgIcon {...props}>
    <g
      id="ICRA-Assessment"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Contributing-Factors-2-Checked"
        transform="translate(-367.000000, -729.000000)"
      >
        <g id="Group" transform="translate(368.000000, 730.000000)">
          <g id="Add-Solution">
            <g id="Add-Solutions">
              <path
                d="M8.5,0 C3.80534375,0 0,3.80375 0,8.5 C0,13.19625 3.80534375,17 8.5,17 C13.1946562,17 17,13.19625 17,8.5 C17,3.80375 13.1946562,0 8.5,0 L8.5,0 Z"
                id="Fill-25"
                stroke="#012345"
                fill="#FFFFFF"
              />
              <path
                d="M11.6875,7.96875 L9.03125,7.96875 L9.03125,5.3125 C9.03125,5.0203125 8.79378125,4.78125 8.5,4.78125 C8.20621875,4.78125 7.96875,5.0203125 7.96875,5.3125 L7.96875,7.96875 L5.3125,7.96875 C5.01871875,7.96875 4.78125,8.2078125 4.78125,8.5 C4.78125,8.7921875 5.01871875,9.03125 5.3125,9.03125 L7.96875,9.03125 L7.96875,11.6875 C7.96875,11.9796875 8.20621875,12.21875 8.5,12.21875 C8.79378125,12.21875 9.03125,11.9796875 9.03125,11.6875 L9.03125,9.03125 L11.6875,9.03125 C11.9812812,9.03125 12.21875,8.7921875 12.21875,8.5 C12.21875,8.2078125 11.9812812,7.96875 11.6875,7.96875 L11.6875,7.96875 Z"
                id="Path"
                fill="#012345"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export { Add, Checked, Unchecked };



// WEBPACK FOOTER //
// ./src/common/muiComponents/checkbox.js